const HEADERS = {
  DEFAULT_HEADER: {
    "Content-Type": "application/json; charset=UTF-8",
  },
  header: () => ({
    "Content-Type": "application/json; charset=UTF-8",
    // Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  }),
  file_header: () => ({
    "Content-Type": "multipart/form-data",
    // Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  }),
  scm_header: () => ({
    "Content-Type": "application/json; charset=UTF-8",
    Authorization: localStorage.getItem("scm_jwt"),
  }),
};

export const API_URLS = {
  AUTO_RANKING: {
    autoRanking: (id) => ({
      endPoint: `/api/v1/journal/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  FILE: {
    uploadFile: (id, type) => ({
      endPoint: `/api/v1/file/storage/${id}?type=${type}`,
      method: "POST",
      headers: HEADERS.file_header(),
    }),
    uploadMultiFile: (id, type = "avatar") => ({
      endPoint: `/api/v1/file/storage/multi/${id}?type=${type}`,
      method: "POST",
      headers: HEADERS.file_header(),
    }),
  },
  PROFILE: {
    getProfileFromUserId: (userId) => ({
      endPoint: `/api/v1/profile/userId/${userId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllProfiles: () => ({
      endPoint: `/api/v1/profile`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getProfileById: (profileId) => ({
      endPoint: `/api/v1/profile/${profileId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateProfile: (profileId) => ({
      endPoint: `/api/v1/profile/${profileId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteProfile: (profileId) => ({
      endPoint: `/api/v1/profile/${profileId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    getTimeResearchByProfileId: (profileId) => ({
      endPoint: `/api/v1/timeResearchInformation/profile/${profileId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getTimeResearchByProfileIdV2: (profileId, startDate, endDate) => ({
      endPoint: `/api/v1/researchHours/profile/v2/${profileId}?startDate=${startDate}&endDate=${endDate}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    filterTimeResearch: () => ({
      endPoint: "/api/v1/timeResearchInformationV2/filter",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    updateTimeResearchInformation: (timeResearchInformationId) => ({
      endPoint: `/api/v1/timeResearchInformation/${timeResearchInformationId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getProfileInfoByProfileId: (profileId) => ({
      endPoint: `/api/v1/profile/info/${profileId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    statisticUnaccepted: () => ({
      endPoint: "/api/v1/statistic/unaccepted",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getProfScore: (profileId) => ({
      endPoint: `/api/v1/profile/score/${profileId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  KPI: {
    updateKpi: (kpiId) => ({
      endPoint: `/api/v1/kpi/${kpiId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  KPI_SCIENTIFIC_RESEARCH: {
    getKpiScientificResearchByKpiId: (kpiId) => ({
      endPoint: `/api/v1/kpiScientificResearch/kpi/${kpiId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getKpiScientificResearchById: (kpiScientificResearchId) => ({
      endPoint: `/api/v1/kpiScientificResearch/${kpiScientificResearchId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateKpiScientificResearchById: (kpiScientificResearchId) => ({
      endPoint: `/api/v1/kpiScientificResearch/${kpiScientificResearchId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    createListKpiScientificResearch: () => ({
      endPoint: `/api/v1/kpiScientificResearch/multiple`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    deleteKpiScientificResearchById: (kpiScientificResearchId) => ({
      endPoint: `/api/v1/kpiScientificResearch/${kpiScientificResearchId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  SCIENTIFIC_COUNCIL: {
    getScientificCouncil: () => ({
      endPoint: `/api/v1/scientificCouncil`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    createScientificCouncil: () => ({
      endPoint: `/api/v1/scientificCouncil`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateScientificCouncil: () => ({
      endPoint: `/api/v1/scientificCouncil`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteScientificCouncil: (scientificCouncilID) => ({
      endPoint: `/api/v1/scientificCouncil/${scientificCouncilID}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  KPI_PATENT: {
    getKpiPatentByKpiId: (kpiId) => ({
      endPoint: `/api/v1/kpiPatent/kpi/${kpiId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getKpiPatentById: (kpiPatentId) => ({
      endPoint: `/api/v1/kpiPatent/${kpiPatentId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateKpiPatentById: (kpiPatentId) => ({
      endPoint: `/api/v1/kpiPatent/${kpiPatentId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    createListKpiPatent: () => ({
      endPoint: `/api/v1/kpiPatent/multiple`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    deleteKpiPatentResearchById: (kpiPatentId) => ({
      endPoint: `/api/v1/kpiPatent/${kpiPatentId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  KPI_PRODUCT_CONTRACT: {
    getKpiProductContractByKpiId: (kpiId) => ({
      endPoint: `/api/v1/kpiProductContract/kpi/${kpiId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getKpiProductContractById: (kpiProductContractId) => ({
      endPoint: `/api/v1/kpiProductContract/${kpiProductContractId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateKpiProductContractById: (kpiProductContractId) => ({
      endPoint: `/api/v1/kpiProductContract/${kpiProductContractId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    createListKpiProductContract: () => ({
      endPoint: `/api/v1/kpiProductContract/multiple`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    deleteKpiProductContractById: (kpiProductContractId) => ({
      endPoint: `/api/v1/kpiProductContract/${kpiProductContractId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  KPI_SOLUTION: {
    getKpiSolutionByKpiId: (kpiId) => ({
      endPoint: `/api/v1/kpiSolution/kpi/${kpiId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getKpiSolutionById: (kpiSolutionId) => ({
      endPoint: `/api/v1/kpiSolution/${kpiSolutionId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    createKpiSolution: () => ({
      endPoint: `/api/v1/kpiSolution`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateKpiSolutionById: (kpiSolutionId) => ({
      endPoint: `/api/v1/kpiSolution/${kpiSolutionId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    createListKpiSolution: () => ({
      endPoint: `/api/v1/kpiSolution/multiple`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    deleteKpiSolutionById: (kpiSolutionId) => ({
      endPoint: `/api/v1/kpiSolution/${kpiSolutionId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  JOURNAL: {
    getAllJournal: () => ({
      endPoint: "/api/v1/journal",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllJournalV2: () => ({
      endPoint: "/api/v1/journal/v2",
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateAllJournal: () => ({
      endPoint: "/api/v1/journal/all",
      method: "POST",
      headers: HEADERS.header(),
    }),
    getFilteredJournal: (page, pageSize) => ({
      endPoint: `/api/v1/journal/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getJournalById: (id) => ({
      endPoint: `/api/v1/journal/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    importJournalByYear: (year) => ({
      endPoint: `/api/v1/journal/importJournal?year=${year}`,
      method: "POST",
      headers: HEADERS.header(),
    }),
  },
  JOURNAL_DOMESTIC: {
    getAllJournalDomestic: () => ({
      endPoint: "/api/v1/journalDomestic",
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertJournalDomestic: () => ({
      endPoint: "/api/v1/journalDomestic",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateJournalDomestic: (id) => ({
      endPoint: `/api/v1/journalDomestic/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteJournalDomestic: (id) => ({
      endPoint: `/api/v1/journalDomestic/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  SCIENTIFIC_RESEARCH: {
    getAllScientificResearch: () => ({
      endPoint: "/api/v1/scientificResearch",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredScientificResearch: (page, pageSize) => ({
      endPoint: `/api/v1/scientificResearch/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    insertScientificResearch: () => ({
      endPoint: "/api/v1/scientificResearch",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateScientificResearch: (id) => ({
      endPoint: `/api/v1/scientificResearch/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteScientificResearch: (id) => ({
      endPoint: `/api/v1/scientificResearch/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    getScientificResearchById: (id) => ({
      endPoint: `/api/v1/scientificResearch/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllScientificResearchById: (id) => ({
      endPoint: `/api/v1/scientificResearch/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    acceptScientificResearch: (id, accept) => ({
      endPoint: `/api/v1/scientificResearch/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllPurpose: () => ({
      endPoint: "/api/v1/purpose",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getDuplicateScientificResearch: () => ({
      endPoint: "/api/v1/scientificResearch/duplicate",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getScientificResearchByLinkedProjectId: (projectId) => ({
      endPoint: `/api/v1/scientificResearch/linkedProject/${projectId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    requestRevisionScientificResearch: (id) => ({
      endPoint: `/api/v1/scientificResearch/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getLinkedProjectCounts: () => ({
      endPoint: "/api/v1/scientificResearch/linkedProjectCounts",
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  SCIENTIFIC_RESEARCH_OTHER: {
    getAllScientificResearchOther: () => ({
      endPoint: "/api/v1/scientificResearchOther",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllScientificResearchOtherByProfileId: (id) => ({
      endPoint: `/api/v1/scientificResearchOther/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertScientificResearchOther: () => ({
      endPoint: "/api/v1/scientificResearchOther",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateScientificResearchOther: (id) => ({
      endPoint: `/api/v1/scientificResearchOther/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteScientificResearchOther: (id) => ({
      endPoint: `/api/v1/scientificResearchOther/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptScientificResearchOther: (id, accept) => ({
      endPoint: `/api/v1/scientificResearchOther/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  PATENT: {
    getAllPatent: () => ({
      endPoint: "/api/v1/patent",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getDuplicatePatent: () => ({
      endPoint: "/api/v1/patent/duplicate",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredPatent: (page, pageSize) => ({
      endPoint: `/api/v1/patent/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getPatentById: (id) => ({
      endPoint: `/api/v1/patent/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllPatentByProfileId: (id) => ({
      endPoint: `/api/v1/patent/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertPatent: () => ({
      endPoint: "/api/v1/patent",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updatePatent: (id) => ({
      endPoint: `/api/v1/patent/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deletePatent: (id) => ({
      endPoint: `/api/v1/patent/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptPatent: (id, accept) => ({
      endPoint: `/api/v1/patent/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionPatent: (id) => ({
      endPoint: `/api/v1/patent/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  SOLUTION: {
    getAllSolution: () => ({
      endPoint: "/api/v1/solution",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getDuplicateSolution: () => ({
      endPoint: "/api/v1/solution/duplicate",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllSolutionById: (id) => ({
      endPoint: `/api/v1/solution/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredSolution: (page, pageSize) => ({
      endPoint: `/api/v1/solution/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getSolutionById: (id) => ({
      endPoint: `/api/v1/solution/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertSolution: () => ({
      endPoint: "/api/v1/solution",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateSolution: (id) => ({
      endPoint: `/api/v1/solution/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteSolution: (id) => ({
      endPoint: `/api/v1/solution/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptSolution: (id, accept) => ({
      endPoint: `/api/v1/solution/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionSolution: (id) => ({
      endPoint: `/api/v1/solution/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  CONTRACT: {
    getAllContract: () => ({
      endPoint: "/api/v1/productContract",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredContract: (page, pageSize) => ({
      endPoint: `/api/v1/productContract/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllContractByProfileId: (id) => ({
      endPoint: `/api/v1/productContract/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getContractById: (id) => ({
      endPoint: `/api/v1/productContract/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertContract: () => ({
      endPoint: "/api/v1/productContract",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateContract: (id) => ({
      endPoint: `/api/v1/productContract/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteContract: (id) => ({
      endPoint: `/api/v1/productContract/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptContract: (id, accept) => ({
      endPoint: `/api/v1/productContract/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionContract: (id) => ({
      endPoint: `/api/v1/productContract/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  PROJECT: {
    getAllProject: () => ({
      endPoint: "/api/v1/researchProject",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredProject: (page, pageSize) => ({
      endPoint: `/api/v1/researchProject/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllProjectByProfileId: (id) => ({
      endPoint: `/api/v1/researchProject/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getProjectById: (id) => ({
      endPoint: `/api/v1/researchProject/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertProject: () => ({
      endPoint: "/api/v1/researchProject",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateProject: (id) => ({
      endPoint: `/api/v1/researchProject/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteProject: (id) => ({
      endPoint: `/api/v1/researchProject/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptProject: (id, accept) => ({
      endPoint: `/api/v1/researchProject/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionProject: (id) => ({
      endPoint: `/api/v1/researchProject/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  MONOGRAPH: {
    getAllMonograph: () => ({
      endPoint: "/api/v1/monograph",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getDuplicateMonograph: () => ({
      endPoint: "/api/v1/monograph/duplicate",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredMonograph: (page, pageSize) => ({
      endPoint: `/api/v1/monograph/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllMonographByProfileId: (id) => ({
      endPoint: `/api/v1/monograph/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertMonograph: () => ({
      endPoint: "/api/v1/monograph",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateMonograph: (id) => ({
      endPoint: `/api/v1/monograph/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteMonograph: (id) => ({
      endPoint: `/api/v1/monograph/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptMonograph: (id, accept) => ({
      endPoint: `/api/v1/monograph/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionMonograph: (id) => ({
      endPoint: `/api/v1/monograph/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  PRESENTATION: {
    getAllPresentation: () => ({
      endPoint: "/api/v1/presentation",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredPresentation: (page, pageSize) => ({
      endPoint: `/api/v1/presentation/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllPresentationByProfileId: (id) => ({
      endPoint: `/api/v1/presentation/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertPresentation: () => ({
      endPoint: "/api/v1/presentation",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updatePresentation: (id) => ({
      endPoint: `/api/v1/presentation/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deletePresentation: (id) => ({
      endPoint: `/api/v1/presentation/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptPresentation: (id, accept) => ({
      endPoint: `/api/v1/presentation/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionPresentation: (id) => ({
      endPoint: `/api/v1/presentation/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  STUDENT_GUIDANCE: {
    getAllStudentGuidance: () => ({
      endPoint: "/api/v1/studentGuidance/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredStudentGuidance: (page, pageSize) => ({
      endPoint: `/api/v1/studentGuidance/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllStudentGuidanceByProfileId: (id) => ({
      endPoint: `/api/v1/studentGuidance/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertStudentGuidance: () => ({
      endPoint: "/api/v1/studentGuidance",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateStudentGuidance: (id) => ({
      endPoint: `/api/v1/studentGuidance/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteStudentGuidance: (id) => ({
      endPoint: `/api/v1/studentGuidance/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptStudentGuidance: (id, accept) => ({
      endPoint: `/api/v1/studentGuidance/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionStudentGuidance: (id) => ({
      endPoint: `/api/v1/studentGuidance/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  RESEARCH_PROPOSAL: {
    getAllResearchProposal: () => ({
      endPoint: "/api/v1/researchProposal",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getDuplicateResearchProposal: () => ({
      endPoint: "/api/v1/researchProposal/duplicate",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredResearchProposal: (page, pageSize) => ({
      endPoint: `/api/v1/researchProposal/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllResearchProposalByProfileId: (id) => ({
      endPoint: `/api/v1/researchProposal/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertResearchProposal: () => ({
      endPoint: "/api/v1/researchProposal",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateResearchProposal: (id) => ({
      endPoint: `/api/v1/researchProposal/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteResearchProposal: (id) => ({
      endPoint: `/api/v1/researchProposal/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptResearchProposal: (id, accept) => ({
      endPoint: `/api/v1/researchProposal/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionResearchProposal: (id) => ({
      endPoint: `/api/v1/researchProposal/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  PROGRAM_DIRECTOR: {
    getAllProgramDirector: () => ({
      endPoint: "/api/v1/programDirector",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredProgramDirector: (page, pageSize) => ({
      endPoint: `/api/v1/programDirector/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllProgramDirectorByProfileId: (id) => ({
      endPoint: `/api/v1/programDirector/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertProgramDirector: () => ({
      endPoint: "/api/v1/programDirector",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateProgramDirector: (id) => ({
      endPoint: `/api/v1/programDirector/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteProgramDirector: (id) => ({
      endPoint: `/api/v1/programDirector/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptProgramDirector: (id, accept) => ({
      endPoint: `/api/v1/programDirector/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionProgramDirector: (id) => ({
      endPoint: `/api/v1/programDirector/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  OTHER_WORK: {
    getAllOtherWork: () => ({
      endPoint: "/api/v1/otherWork",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getFilteredOtherWork: (page, pageSize) => ({
      endPoint: `/api/v1/otherWork/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllOtherWorkByProfileId: (id) => ({
      endPoint: `/api/v1/otherWork/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertOtherWork: () => ({
      endPoint: "/api/v1/otherWork",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateOtherWork: (id) => ({
      endPoint: `/api/v1/otherWork/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteOtherWork: (id) => ({
      endPoint: `/api/v1/otherWork/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptOtherWork: (id, accept) => ({
      endPoint: `/api/v1/otherWork/accepted/${id}?accepted=${accept}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestRevisionOtherWork: (id) => ({
      endPoint: `/api/v1/otherWork/${id}/request-revision`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },

  EMPLOYMENT_CONTRACT: {
    getAllEmploymentContract: () => ({
      endPoint: "/api/v1/contract",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllEmploymentContractByProfileId: (profileId) => ({
      endPoint: `/api/v1/contract/profileId/${profileId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getEmploymentContractById: (id) => ({
      endPoint: `/api/v1/contract/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getEmploymentContractInfoById: (id) => ({
      endPoint: `/api/v1/contract/info/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertEmploymentContract: () => ({
      endPoint: "/api/v1/contract",
      method: "POST",
      headers: HEADERS.header(),
    }),
    filterEmploymentContract: () => ({
      endPoint: "/api/v1/contract/filter",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    updateEmploymentContract: (id) => ({
      endPoint: `/api/v1/contract/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteEmploymentContract: (id) => ({
      endPoint: `/api/v1/contract/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    activateEmploymentContract: (id, active) => ({
      endPoint: `/api/v1/contract/active/${id}?active=${String(!!active)}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    updateKpiCompletedContract: (id, completed) => ({
      endPoint: `/api/v1/contract/completed/${id}?completed=${String(!!completed)}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    checkKpi: (contractId) => ({
      endPoint: `/api/v1/contract/kpi/${contractId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateReceiveNotiEmploymentContract: (id, receiveNoti) => ({
      endPoint: `/api/v1/contract/receiveNoti/${id}?receiveNoti=${String(!!receiveNoti)}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    // KPI
    updateKPI: (id) => ({
      endPoint: `/api/v1/kpi/v2/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    updateKPICompleted: (id, completed) => ({
      endPoint: `/api/v1/kpi/completed/${id}?completed=${completed}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    createKPI: () => ({
      endPoint: "/api/v1/kpi",
      method: "POST",
      headers: HEADERS.header(),
    }),
    deleteKPI: (id) => ({
      endPoint: `/api/v1/kpi/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    getKpiRewardInfo: (id) => ({
      endPoint: `/api/v1/contract/kpireward/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  USER: {
    login: () => ({
      endPoint: "/api/v1/login",
      method: "POST",
      headers: HEADERS.header(),
    }),
    logout: () => ({
      endPoint: "/api/v1/logout",
      method: "POST",
      headers: HEADERS.header(),
    }),
    loginLDAP: () => ({
      endPoint: "/api/v1/login/ldap",
      method: "POST",
      headers: HEADERS.header(),
    }),
    loginWithGoogle: () => ({
      endPoint: "/api/v1/login/google",
      method: "POST",
      headers: HEADERS.header(),
    }),
    refreshToken: () => ({
      endPoint: "/api/v1/token/refresh",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updatePassword: () => ({
      endPoint: "/api/v1/user/change",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getAllUsers: () => ({
      endPoint: "/api/v1/user/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    createNewUser: () => ({
      endPoint: "/api/v1/user",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateRole: () => ({
      endPoint: "/api/v1/user/role",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteUserById: (userId) => ({
      endPoint: `/api/v1/user/${userId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  COUNCIL: {
    getAllCouncil: () => ({
      endPoint: "/api/v1/council/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    filterCouncil: () => ({
      endPoint: "/api/v1/student_council/filter",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    insertCouncil: () => ({
      endPoint: "/api/v1/student_council/create",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateCouncil: () => ({
      endPoint: "/api/v1/student_council/update",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteCouncil: (id) => ({
      endPoint: `/api/v1/student_council/delete/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    insertInternalCouncil: () => ({
      endPoint: "/api/v1/int_council/create",
      method: "POST",
      headers: HEADERS.header(),
    }),
  },
  CONFERENCE: {
    getAllConference: () => ({
      endPoint: "/api/v1/conference",
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertConference: () => ({
      endPoint: "/api/v1/conference",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateConference: (id) => ({
      endPoint: `/api/v1/conference/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteConference: (id) => ({
      endPoint: `/api/v1/conference/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    importConferenceByYear: (year) => ({
      endPoint: `/api/v1/conference/importInternationalConference?year=${year}`,
      method: "POST",
      headers: HEADERS.header(),
    }),
  },
  DEPARTMENT: {
    getAllDepartments: () => ({
      endPoint: "/api/v1/department/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAllFaculties: () => ({
      endPoint: "/api/v1/department/faculties",
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertDepartment: () => ({
      endPoint: "/api/v1/department",
      method: "POST",
      headers: HEADERS.header(),
    }),
    getDepartmentById: (departmentId) => ({
      endPoint: `/api/v1/department/${departmentId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateDepartment: (departmentId) => ({
      endPoint: `/api/v1/department/${departmentId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteDepartment: (departmentId) => ({
      endPoint: `/api/v1/department/${departmentId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    getAllProfiles: () => ({
      endPoint: "/api/v1/profile",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getProfileByDepartmentId: (departmentId) => ({
      endPoint: `/api/v1/profile/department/${departmentId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    addProfileToDepartment: () => ({
      endPoint: "/api/v1/departmentProfile",
      method: "POST",
      headers: HEADERS.header(),
    }),
    deleteProfileFromDepartment: (departmentProfileId) => ({
      endPoint: `/api/v1/departmentProfile/${departmentProfileId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    updateDepartmentProfileById: (departmentProfileId) => ({
      endPoint: `/api/v1/departmentProfile/${departmentProfileId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  TIME_RESEARCH_INFORMATION: {
    getAllTimeResearchInformation: () => ({
      endPoint: "/api/v1/timeResearchInformation",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getTimeResearchInformation: () => ({
      endPoint: "/api/v1/timeResearchInformation/filter?page=1&pageSize=-1",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getTimeResearchStatistic: () => ({
      endPoint: "/api/v1/statistic/timeResearch",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getTimeResearchInformationById: (id) => ({
      endPoint: `/api/v1/timeResearchInformation/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertTimeResearchInformation: () => ({
      endPoint: "/api/v1/timeResearchInformation",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateTimeResearchInformation: (id) => ({
      endPoint: `/api/v1/timeResearchInformation/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    updateTimeResearchDetail: (id) => ({
      endPoint: `/api/v1/timeResearchInformation/timeResearchDetail/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteTimeResearchInformation: (id) => ({
      endPoint: `/api/v1/timeResearchInformation/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    calculateTimeResearch: (profileId, year) => ({
      endPoint: `/api/v1/timeResearchInformation/calTimeResearch?profileId=${profileId}&year=${year}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    calculateTimeResearchAllProfile: (year) => ({
      endPoint: `/api/v1/timeResearchInformation/calTimeResearchAllProfile?year=${year}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    createTimeResearchInformationFromSample: () => ({
      endPoint: `/api/v1/timeResearchInformation`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    lockTimeResearch: (id, locked) => ({
      endPoint: `/api/v1/timeResearchInformation/locked/id/${id}?locked=${locked}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    lockAllTimeResearch: (year, locked) => ({
      endPoint: `/api/v1/timeResearchInformation/locked/${year}?locked=${locked}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getResearchHours: () => ({
      endPoint: `/api/v1/researchHours`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getResearchHourStats: () => ({
      endPoint: `/api/v1/researchHours/stats`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getResearchHourStatsByTask: () => ({
      endPoint: `/api/v1/researchHours/stats/by-task`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    // Advanced report endpoints — same body, ?format=json|xlsx.
    reportTotals: (format) => ({
      endPoint: `/api/v1/researchHours/reports/totals?format=${format || "json"}`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    reportQuotaStatus: (format) => ({
      endPoint: `/api/v1/researchHours/reports/quota-status?format=${format || "json"}`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    reportWorks: (format) => ({
      endPoint: `/api/v1/researchHours/reports/works?format=${format || "json"}`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    recalculateResearchHours: () => ({
      endPoint: `/api/v1/researchHours/recalculate`,
      method: "POST",
      headers: HEADERS.header(),
    }),
  },
  WORKS: {
    // Shared export endpoint — POST {workType, ids} → .xlsx Blob.
    // Used by the "Xuất Excel" button on every Management table.
    exportWorks: () => ({
      endPoint: `/api/v1/works/export`,
      method: "POST",
      headers: HEADERS.header(),
    }),
  },
  RESEARCH_HOUR_CONFIG: {
    getYearQuota: (year) => ({
      endPoint: `/api/v1/researchHourConfig/yearQuota?year=${year}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    listYearQuotas: () => ({
      endPoint: `/api/v1/researchHourConfig/yearQuota/list`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    upsertYearQuota: () => ({
      endPoint: `/api/v1/researchHourConfig/yearQuota`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    listReductions: (year) => ({
      endPoint: `/api/v1/researchHourConfig/reductions?year=${year}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    upsertReduction: () => ({
      endPoint: `/api/v1/researchHourConfig/reduction`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteReduction: (profileId, year) => ({
      endPoint: `/api/v1/researchHourConfig/reduction?profileId=${profileId}&year=${year}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    yearStatus: (year) => ({
      endPoint: `/api/v1/researchHourConfig/yearStatus?year=${year}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    closeYear: () => ({
      endPoint: `/api/v1/researchHourConfig/closeYear`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    reopenYear: () => ({
      endPoint: `/api/v1/researchHourConfig/reopenYear`,
      method: "POST",
      headers: HEADERS.header(),
    }),
  },
  SYSTEM_MAIL_TEMPLATE: {
    list: () => ({
      endPoint: "/api/v1/systemMailTemplate",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getByKey: (key) => ({
      endPoint: `/api/v1/systemMailTemplate/${key}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    upsert: () => ({
      endPoint: "/api/v1/systemMailTemplate",
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  GENERAL_CONFIG: {
    list: () => ({
      endPoint: "/api/v1/generalConfig",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getByKey: (key) => ({
      endPoint: `/api/v1/generalConfig/${key}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    upsert: () => ({
      endPoint: "/api/v1/generalConfig",
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  REWARD_INFORMATION: {
    getRewardInformation: () => ({
      endPoint: "/api/v1/rewardInformation",
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateRewardInformation: (id) => ({
      endPoint: `/api/v1/rewardInformation/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getRewardInformationV2: () => ({
      endPoint: "/api/v1/rewardInfoV2",
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateRewardInformationV2: (id) => ({
      endPoint: `/api/v1/rewardInfoV2/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  RESEARCH_REWARD: {
    getResearchRewards: () => ({
      endPoint: `/api/v1/researchRewards`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    recalculateResearchRewards: () => ({
      endPoint: `/api/v1/researchRewards/recalculate`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateResearchRewardStatus: () => ({
      endPoint: `/api/v1/researchRewards/status`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    forceUnlock: (workId) => ({
      endPoint: `/api/v1/researchRewards/force-unlock/${workId}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    forceRecalcOne: () => ({
      endPoint: `/api/v1/researchRewards/force-recalc-one`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    getStatistic: () => ({
      endPoint: `/api/v1/researchRewards/statistic`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getWorkStudents: () => ({
      endPoint: `/api/v1/researchRewards/work-students`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    explain: () => ({
      endPoint: `/api/v1/researchRewards/explain`,
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  REWARD_BONUS_CONFIG: {
    getAll: () => ({ endPoint: `/api/v1/rewardBonusConfig`, method: "GET", headers: HEADERS.header() }),
    getActive: () => ({ endPoint: `/api/v1/rewardBonusConfig/active`, method: "GET", headers: HEADERS.header() }),
    create: () => ({ endPoint: `/api/v1/rewardBonusConfig`, method: "POST", headers: HEADERS.header() }),
    update: (id) => ({ endPoint: `/api/v1/rewardBonusConfig/${id}`, method: "PUT", headers: HEADERS.header() }),
    remove: (id) => ({ endPoint: `/api/v1/rewardBonusConfig/${id}`, method: "DELETE", headers: HEADERS.header() }),
  },
  REWARD_GLOBAL_CONFIG: {
    getAll: () => ({ endPoint: `/api/v1/rewardGlobalConfig`, method: "GET", headers: HEADERS.header() }),
    getByKey: (key) => ({ endPoint: `/api/v1/rewardGlobalConfig/${key}`, method: "GET", headers: HEADERS.header() }),
    upsert: () => ({ endPoint: `/api/v1/rewardGlobalConfig`, method: "PUT", headers: HEADERS.header() }),
  },
  RANK_TABLE: {
    getRankTable: () => ({
      endPoint: "/api/v1/rankTable",
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateRankTable: (id) => ({
      endPoint: `/api/v1/rankTable/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  EARNINGS_TABLE: {
    getEarningsTable: () => ({
      endPoint: "/api/v1/earningsTable",
      method: "GET",
      headers: HEADERS.header(),
    }),
    updateEarningsTable: (id) => ({
      endPoint: `/api/v1/earningsTable/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  STATISTIC: {
    getFinishContractStatistic: () => ({
      endPoint: "/api/v1/statistic/almostFinishContract",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getReviewContractStatistic: () => ({
      endPoint: "/api/v1/statistic/reviewContract",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getScientificResearchStatistic: () => ({
      endPoint: "/api/v1/statistic/scientificResearch",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getRewardContractStatistic: (page, pageSize) => ({
      endPoint: `/api/v1/contract/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    handleUpdateKpiCompleted: (year, completed) => ({
      endPoint: `/api/v1/kpi/completed/year/${year}?completed=${completed}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    getContractRewardByYear: (year) => ({
      endPoint: `/api/v1/contract/kpireward/year/${year}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  NOTIFICATION: {
    sendTimerNotification: () => ({
      endPoint: "/api/v1/timerNotifications/timerNotification/",
      method: "POST",
      headers: HEADERS.header(),
    }),
    sendEmail: () => ({
      endPoint: "/api/v1/emails/email",
      method: "POST",
      headers: HEADERS.header(),
    }),
  },
  REWARD: {
    getFilteredProfileReward: (page, pageSize) => ({
      endPoint: `/api/v1/rewardProfile/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    calProfileReward: () => ({
      endPoint: "/api/v1/profile/reward",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    calAllProfileReward: () => ({
      endPoint: "/api/v1/profile/rewardAllProfile",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteProfileReward: (id) => ({
      endPoint: `/api/v1/rewardProfile/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    acceptProfileReward: (id, accepted) => ({
      endPoint: `/api/v1/rewardProfile/accepted/${id}?accepted=${accepted}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    lockProfileReward: (id, locked) => ({
      endPoint: `/api/v1/rewardProfile/locked/${id}?locked=${locked}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    lockAllProfileReward: (year, locked) => ({
      endPoint: `/api/v1/rewardProfile/locked/year/${year}?locked=${locked}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  YEARLY_DUE_DATE: {
    getAllYearlyDueDate: () => ({
      endPoint: "/api/v1/due/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    filterYearlyDueDate: () => ({
      endPoint: "/api/v1/due/filter",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    updateYearlyDueDate: () => ({
      endPoint: "/api/v1/due/update",
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  STUDENT_RESEARCH: {
    getAllStudentResearch: () => ({
      endPoint: "/api/v1/stu_research/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertStudentResearch: () => ({
      endPoint: "/api/v1/stu_research/create",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateStudentResearch: () => ({
      endPoint: "/api/v1/stu_research/update",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteStudentResearch: (id) => ({
      endPoint: `/api/v1/stu_research/delete/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    updateStudentResearchStatus: (id, status) => ({
      endPoint: `/api/v1/stu_research/status/${id}?status=${status}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    filterStudentResearch: () => ({
      endPoint: "/api/v1/stu_research/filter",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    filterStudentResearchV2: () => ({
      endPoint: "/api/v1/stu_research/filter/v2",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    insertStudentGuidance: () => ({
      endPoint: "/api/v1/student_guidance/create",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateStudentGuidance: () => ({
      endPoint: "/api/v1/student_guidance/update",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteStudentGuidance: (id) => ({
      endPoint: `/api/v1/student_guidance/delete/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },
  INTERNAL_RESEARCH: {
    getAllInternalResearch: () => ({
      endPoint: "/api/v1/int_research/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertInternalResearch: () => ({
      endPoint: "/api/v1/int_research/create",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateInternalResearch: () => ({
      endPoint: "/api/v1/int_research/update",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    updateInternalResearchStatus: (id, status, oldStatus) => ({
      endPoint: `/api/v1/int_research/status/${id}?status=${status}&oldStatus=${oldStatus}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteInternalResearch: (id) => ({
      endPoint: `/api/v1/int_research/delete/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    filterInternalResearch: () => ({
      endPoint: "/api/v1/int_research/filter",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    filterInternalResearchV2: () => ({
      endPoint: "/api/v1/int_research/filter/v2",
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },
  INTELLECTUAL_PROPERTY: {
    getAllIntellectualProperty: () => ({
      endPoint: "/api/v1/intellectual-property/",
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertIntellectualProperty: () => ({
      endPoint: "/api/v1/intellectual-property/",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateIntellectualProperty: () => ({
      endPoint: "/api/v1/intellectual-property/",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteIntellectualProperty: (id) => ({
      endPoint: `/api/v1/intellectual-property/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    getAllFeeTpye: () => ({
      endPoint: "/api/v1/intellectual-property/fee-type",
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  HRM: {
    // Định mức giờ nghiên cứu
    getDmTimeReseach: () => ({
      endPoint: "/api/v1/timeResearchInformationV2/norm",
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
  AUDIT_LOG: {
    getAuditLogByModel: (modelType, modelId) => ({
      endPoint: `/api/v1/auditLog/model/${modelType}/${modelId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getAuditLogById: (id) => ({
      endPoint: `/api/v1/auditLog/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    filterAuditLog: (page, pageSize) => ({
      endPoint: `/api/v1/auditLog/filter?page=${page}&pageSize=${pageSize}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
  },

  // [VinUni] Module 8 - Quản lý văn bản
  DOCUMENT: {
    getAllDocument: () => ({
      endPoint: "/api/v1/document/all",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getDocumentById: (id) => ({
      endPoint: `/api/v1/document/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getDocumentByDepartmentId: (departmentId) => ({
      endPoint: `/api/v1/document/department/${departmentId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertDocument: () => ({
      endPoint: "/api/v1/document",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateDocument: (id) => ({
      endPoint: `/api/v1/document/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteDocument: (id) => ({
      endPoint: `/api/v1/document/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
  },

  // [VinUni] Module 6 - Hợp đồng TLNC (RA)
  RA_CONTRACT: {
    getAllContract: () => ({
      endPoint: "/api/v1/contract",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getContractById: (id) => ({
      endPoint: `/api/v1/contract/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getContractByProfileId: (id) => ({
      endPoint: `/api/v1/contract/profileId/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insertContract: () => ({
      endPoint: "/api/v1/contract",
      method: "POST",
      headers: HEADERS.header(),
    }),
    updateContract: (id) => ({
      endPoint: `/api/v1/contract/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deleteContract: (id) => ({
      endPoint: `/api/v1/contract/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    setActiveContract: (id, active) => ({
      endPoint: `/api/v1/contract/active/${id}?active=${active}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    setCompletedContract: (id, completed) => ({
      endPoint: `/api/v1/contract/completed/${id}?completed=${completed}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    addAcceptance: (id) => ({
      endPoint: `/api/v1/contract/${id}/acceptance`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    deleteAcceptance: (acceptanceId) => ({
      endPoint: `/api/v1/contract/acceptance/${acceptanceId}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    getAvailablePapers: (profileId) => ({
      endPoint: `/api/v1/contract/available-papers/${profileId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getWarnings: (profileId) => ({
      endPoint: `/api/v1/contract/warnings?profileId=${profileId || 0}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
  },

  // [VinUni] Quản lý đề tài
  RESEARCH_TOPIC: {
    getAll: () => ({
      endPoint: "/api/v1/researchTopic",
      method: "GET",
      headers: HEADERS.header(),
    }),
    getById: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    getByProfileId: (profileId) => ({
      endPoint: `/api/v1/researchTopic/profileId/${profileId}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    filter: (page, pageSize) => ({
      endPoint: `/api/v1/researchTopic/filter?page=${page || 1}&pageSize=${pageSize || -1}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    dashboard: (profileId) => ({
      endPoint: `/api/v1/researchTopic/dashboard${profileId ? `?profileId=${profileId}` : ""}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    statistics: () => ({
      endPoint: "/api/v1/researchTopic/statistics",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    exportStatistics: () => ({
      endPoint: "/api/v1/researchTopic/statistics/export",
      method: "PUT",
      headers: HEADERS.header(),
    }),
    deadlines: (bucket) => ({
      endPoint: `/api/v1/researchTopic/deadlines?bucket=${bucket || ""}`,
      method: "GET",
      headers: HEADERS.header(),
    }),
    insert: () => ({
      endPoint: "/api/v1/researchTopic",
      method: "POST",
      headers: HEADERS.header(),
    }),
    update: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    delete: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}`,
      method: "DELETE",
      headers: HEADERS.header(),
    }),
    submit: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/submit`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    approve: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/approve`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    returnToDraft: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/return`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    resume: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/resume`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    changeStatus: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/status`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    close: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/close`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestAcceptance: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/request-acceptance`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    setAcceptance: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/acceptance`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    addProgressReport: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/progress-report`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    requestExtension: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/extension`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    approveExtension: (extId, approve) => ({
      endPoint: `/api/v1/researchTopic/extension/${extId}/approve?approve=${approve}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    requestStop: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/stop-request`,
      method: "POST",
      headers: HEADERS.header(),
    }),
    approveStop: (reqId, approve) => ({
      endPoint: `/api/v1/researchTopic/stop-request/${reqId}/approve?approve=${approve}`,
      method: "PUT",
      headers: HEADERS.header(),
    }),
    sendEmail: () => ({
      endPoint: "/api/v1/researchTopic/send-email",
      method: "POST",
      headers: HEADERS.header(),
    }),
    getEmailLogs: (id) => ({
      endPoint: `/api/v1/researchTopic/${id}/email-logs`,
      method: "GET",
      headers: HEADERS.header(),
    }),
  },
};

